// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef, Directive } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppMetaDataService, LicensesEntity, AppMetaDataLookups, PayJobChangeEntity, EthosUserEntity } from 'src/app/meta-data/app-meta-data.service';
import { flatMap, combineLatest, map, last, debounceTime } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { AbstractControl, FormControl } from '@angular/forms';
import { ConfigService } from 'src/environments/environment';
import { NumberSequence } from 'ag-grid-community';
import { PayJobChangeService } from '../../services/pay-job-change.service';



@Directive()
export abstract class EthosUserInfoBaseComponent extends DwSectionBaseComponent<DwComponentSectionPreference>
    implements OnInit {

    lookupId: number;
    lookupValue: number;

    // fileId: number;
    constructor(dwExpressionService: DwExpressionService,
        dwUiConfigRegistryService: DwUiConfigRegistryService,
        private msalHandler: DwSecuritySSOService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,

        // Imports for this component
        private payJobChangeService: PayJobChangeService,
        private messageService: DwMessagingService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }

    ngOnInit() {

        super.ngOnInit();

        this.lookupId = this.getLookupId();

        this.formGroup.valueChanges
            .pipe(debounceTime(200))
            .subscribe(formValue => {
                this.setupTrustUserValues();
            });

        this.setupTrustUserValues();
    }

    setupTrustUserValues() {
        const employeeUserId = this.getEmployeeUserId;

        this.payJobChangeService.getEthosUser(employeeUserId)
            .subscribe(user => {

                if (!user) {
                    this.setLookupValue(null);
                    return;
                }

                this.setTrustUserValues(user);
            });
    }



    get getEmployeeUserId() {

        if (!this.formGroup.value) {
            return null;
        }

        return this.formGroup.value['EmployeeEthos_UserId'];
    }

    setLookupValue(value) {
        this.lookupValue = value;
    }

    abstract setTrustUserValues(user: EthosUserEntity);
    abstract getLookupId(): number;


}
